export default __webpack_public_path__ + "static/Net_Pfade_Light_reverse_v2 Kopie-dbad4a521b7c1f96459226c0ecf3bc12.svg";